import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description Recommendation Api Service
 */
const RecommendationApiService = {
  // Recommendations customize api
  getData: async (selectedAccount, type, date, filterData = null, isForceRefresh = false) => {
    // Get history
    if (date && type === 'ALL_SERVICES') {
      const endpoint = APIConstants.ENDPOINT_RECOMMENDATION_HISTORY
      let url = `${endpoint}?type=${type}`

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        // if (parseToJson['userAccounts'] && parseToJson['userAccounts'][0] && parseToJson['userAccounts'][0]['accountId']) {
        //   url += `&userAccountId=${parseToJson['userAccounts'][0]['accountId']}`
        // }
        if (selectedAccount) {
          url += `&userAccountId=${selectedAccount}`
        }

        if (parseToJson['userId']) {
          url += `&userId=${parseToJson['userId']}`
        }

        if (type === 'ALL_SERVICES' && date) {
          url += `&date=${date}`
        }

        if (isForceRefresh) {
          url += `&isForceRefresh=${isForceRefresh}`
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      try {
        return await APIService.get(url)
      } catch (err) {
        DebugService.error(`Recommendation Api Service: Error Caught while fetching recommendations for ${type}`, err)
      }
    } else {
      // Get recommendations
      const url = APIConstants.ENDPOINT_RECOMMENDATION
      const dataRequest = {
        type,
      }
      if (isForceRefresh && type !== 'ALL_SERVICES') {
        dataRequest['isForceRefresh'] = true
      }

      if (filterData?.['tag'] !== '' && filterData?.['values']?.length > 0 ) {
        dataRequest['filterKey'] = filterData?.['tag']
        dataRequest['filterValues'] = filterData?.['values']
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      try {
        return await APIService.post(url, dataRequest)
      } catch (err) {
        DebugService.error(`Recommendation Api Service: Error Caught while fetching recommendations for ${type}`, err)
      }
    }
  },

  getAzureData: async (data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      if (data?.type === 'AZURE_ADVISORYS') {
        return await APIService.post(APIConstants.ENDPOINT_RECOMMENDATION, data)
      }

      return await AzureAPIService.post(APIConstants.ENDPOINT_AZURE_RECOMMENDATION, data)
    } catch (err) {
      DebugService.error(`Recommendation Api Service: Caught error while fetching azure recommendations`, err)
    }
  },
};

export default RecommendationApiService;
